// @flow
import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import type { Node } from 'react'

type Props = {|
  acceptType: ?string,
  className?: string,
  onSelect?: Function,
  style?: Object,
  multiple?: boolean,
  children?: Node
|}

export default class DropZone extends Component<Props> {
  dropzone: any

  static defaultProps = {
    className: '',
    style: {}
  }

  render() {
    const { acceptType, className, style, multiple } = this.props

    return (
      <Dropzone
        accept={acceptType}
        ref={(el) => {
          this.dropzone = el
        }}
        className={className}
        style={style}
        disableClick
        disablePreview
        multiple={!!multiple}
        onDropAccepted={(files) => this.accepted(files)}
      >
        {this.props.children}
      </Dropzone>
    )
  }

  // Used from outside
  open() {
    this.dropzone.open()
  }

  accepted(files: Array<any>) {
    const { onSelect } = this.props

    onSelect && onSelect(files)
  }
}
